import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import LogoCarousel from '../components/LogoCarousel';
import Stats from '../components/Stats';
import About from '../components/About';
import Experience from '../components/Experience';
import Leadership from '../components/Leadership';
import Education from '../components/Education';
import Skills from '../components/Skills';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import OrganizationsFounded from '../components/WebsiteEmbeds';
import FeaturedPress from '../components/FeaturedPress';
import PhotoGallery from '../components/PhotoGallery';
import Certifications from '../components/Certifications';
import Projects from '../components/Projects';
import MobileContactFAB from '../components/MobileContactFAB';
import AIAssistant from '../components/AIAssistant';
import WelcomeIntro from '../components/WelcomeIntro';
import { ExitIntentModal } from '../components/ExitIntentModal';
import { SectionTracker } from '../components/SectionTracker';
import { AnalyticsPanel } from '../components/AnalyticsPanel';
import { useLanguage } from '../context/LanguageContext';
import { useAnalytics } from '../context/AnalyticsContext';
const Home = () => {
  const {
    language,
    toggleLanguage
  } = useLanguage();
  const {
    trackPageVisit
  } = useAnalytics();
  // Track page visit on mount
  useEffect(() => {
    trackPageVisit('Home');
  }, [trackPageVisit]);
  // Initialize intersection observer for scroll animations
  useEffect(() => {
    const observerCallback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          const elements = entry.target.querySelectorAll('.fade-in, .slide-in-left, .slide-in-right, .scale-in, .staggered-text, .slide-up');
          elements.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add('active');
            }, index * 100);
          });
        }
      });
    };
    const observer = new IntersectionObserver(observerCallback, {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    });
    document.querySelectorAll('section, .section-transition, .staggered-text, .slide-up').forEach(section => {
      observer.observe(section);
    });
    return () => {
      observer.disconnect();
    };
  }, []);
  const handleLanguageSelect = (lang: 'en' | 'vi') => {
    if (lang === 'vi' && language === 'en') {
      toggleLanguage();
    } else if (lang === 'en' && language === 'vi') {
      toggleLanguage();
    }
  };
  return <div className="w-full min-h-screen bg-background text-primary font-body overflow-x-hidden" data-id="element-1222">
      <WelcomeIntro onLanguageSelect={handleLanguageSelect} data-id="element-1223" />
      <Navbar language={language} toggleLanguage={toggleLanguage} data-id="element-1224" />

      <SectionTracker sectionName="Hero" data-id="element-1225">
        <Hero language={language} toggleLanguage={toggleLanguage} data-id="element-1226" />
      </SectionTracker>

      <SectionTracker sectionName="Logo Carousel" data-id="element-1227">
        <LogoCarousel data-id="element-1228" />
      </SectionTracker>

      <SectionTracker sectionName="Stats" data-id="element-1229">
        <Stats language={language} data-id="element-1230" />
      </SectionTracker>

      <SectionTracker sectionName="About" data-id="element-1231">
        <About language={language} data-id="element-1232" />
      </SectionTracker>

      <SectionTracker sectionName="Photo Gallery" data-id="element-1233">
        <PhotoGallery language={language} data-id="element-1234" />
      </SectionTracker>

      <SectionTracker sectionName="Education" data-id="element-1235">
        <Education language={language} data-id="element-1236" />
      </SectionTracker>

      <SectionTracker sectionName="Experience" data-id="element-1237">
        <Experience language={language} data-id="element-1238" />
      </SectionTracker>

      <SectionTracker sectionName="Certifications" data-id="element-1239">
        <Certifications language={language} data-id="element-1240" />
      </SectionTracker>

      <SectionTracker sectionName="Skills" data-id="element-1241">
        <Skills language={language} data-id="element-1242" />
      </SectionTracker>

      <SectionTracker sectionName="Organizations Founded" data-id="element-1243">
        <OrganizationsFounded language={language} data-id="element-1244" />
      </SectionTracker>

      <SectionTracker sectionName="Featured Press" data-id="element-1245">
        <FeaturedPress language={language} data-id="element-1246" />
      </SectionTracker>

      <SectionTracker sectionName="Projects" data-id="element-1247">
        <Projects language={language} data-id="element-1248" />
      </SectionTracker>

      <SectionTracker sectionName="Leadership" data-id="element-1249">
        <Leadership language={language} data-id="element-1250" />
      </SectionTracker>

      <SectionTracker sectionName="Contact" data-id="element-1251">
        <Contact language={language} data-id="element-1252" />
      </SectionTracker>

      <Footer language={language} data-id="element-1253" />
      <MobileContactFAB language={language} data-id="element-1254" />
      <AIAssistant data-id="element-1255" />
      <ExitIntentModal data-id="element-1256" />
      <AnalyticsPanel data-id="element-1257" />
    </div>;
};
export default Home;